import { SwitchField, TextField } from '@app/components/common';
import { Form } from '@app/components/common/form/form';
import { QueryTable } from '@app/components/common/table';
import { useAlert, useApi, useEntityState } from '@app/hooks';

export type PositionFormProps = {
  initial: EntityBase;
  onSubmit?(instance: EntityBase): Promise<void>;
  onCancel?(): void;
};

export const PositionsForm = ({
  initial,
  onSubmit,
  onCancel,
}: PositionFormProps) => {
  const { info, error } = useAlert();
  const api = useApi();
  const [instance, onChange] = useEntityState<EntityBase>(initial);
  const { refetch } = QueryTable.useQueryTable();

  const onSubmitForm = async (instance: Partial<EntityBase>) => {
    let response;
    if (initial) {
      response = await api.users.modifyPosition({
        id: instance.id,
        name: instance.name,
        is_active: instance.is_active,
      });
    } else {
      response = await api.users.createPosition({
        name: instance.name
      });
    }
    
    if (response?.code === 200) {
      await refetch();
      info(response.message);
      onSubmit(instance);
    }
  };
  return <Form 
    instance={instance}
    onSubmit={onSubmitForm}
    onCancel={onCancel}
    onChange={onChange}
  >
    <Form.Item
      label="Наименование"
      field='name'
      required
      component={TextField}
      span={{ md: 12 }}
    />
    {initial && <Form.Item
      label="Активность"
      field='is_active'
      component={SwitchField}
      span={{ md: 12 }}
    />}
  </Form>;
};